var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{staticClass:"md-layout md-gutter md-alignment-center-center-space-around"},[_c('div',{staticClass:"md-layout-item md-size-100 logo"},[_c('figure',[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.svg")}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }